function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0,0h24v24H0V0z"
})), /*#__PURE__*/React.createElement("g", {
  id: "rial-symbol-currency",
  transform: "translate(-1064 -24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFD465",
  cx: 1076,
  cy: 36,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2A60D",
  d: "M1076,47c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S1082.1,47,1076,47z M1076,27c-5,0-9,4-9,9 c0,5,4,9,9,9c5,0,9-4,9-9C1085,31,1081,27,1076,27z"
})), /*#__PURE__*/React.createElement("g", {
  id: "iran-rial",
  transform: "translate(1068.636 30.455)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16",
  fill: "#A77C11",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  d: "M8.9,7.7L8.9,7.7h0.7h0.1h0.8c0.1,0,0.1-0.1,0.1-0.1c0.1-1.9,0-2.7-0.6-3.2c0,0-0.1,0-0.1,0h0 c0,0-0.1,0-0.1,0.1c-0.3,0.4-0.3,0.9,0,1.3c0.1,0.2,0.2,0.4,0.2,0.7c0,0.1,0,0.2,0.1,0.3H9.6H9.5H8.9c-0.4,0-0.6,0-0.9,0h0 c-0.3,0-0.5-0.1-0.5-0.4c0-0.4-0.1-0.9-0.1-1.3c0-0.6-0.1-1.2-0.1-1.5C7.1,2.9,7,2.3,6.8,1.8c0-0.1-0.1-0.1-0.1-0.1 c-0.1,0-0.1,0-0.1,0.1c0,0.1-0.1,0.2-0.1,0.2C6.4,2.3,6.3,2.5,6.3,2.7c0,0.5,0.1,0.9,0.2,1.4v0C6.6,4.4,6.6,4.7,6.7,5 s0.1,0.6,0.1,0.9c0,0.3,0.1,0.7,0.1,1C7,7.4,7.3,7.7,7.7,7.7C8.1,7.7,8.4,7.7,8.9,7.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  d: "M8.7,8.8l0.5,0.6c0,0,0,0,0.1,0h0c0,0,0.1,0,0.1,0L10,8.8c0,0,0.1-0.1,0-0.2L9.4,8 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0L8.7,8.5c0,0,0,0,0,0.1L8.2,8c0,0-0.1,0-0.1,0C8,8,8,8,8,8L7.5,8.5c-0.1,0-0.1,0.1,0,0.2L8,9.3 c0,0,0.1,0,0.1,0l0,0c0,0,0.1,0,0.1,0L8.7,8.8C8.7,8.8,8.7,8.8,8.7,8.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  d: "M5.9,2C5.9,1.7,5.7,1.5,5.5,1.4C5.4,1.4,5.3,1.3,5.2,1.2C5.1,1.1,5.1,1.1,5,1C5,1,5,1,4.9,1h0 c0,0-0.1,0-0.1,0.1c-0.2,0.5-0.3,1-0.1,1.5l0,0.1c0.2,1,0.4,2,0.4,3l0,0.4C5.4,6.6,5.3,7,5,7.4C4.7,7.8,4.2,7.9,3.7,7.9 c-0.1,0-0.2,0-0.3,0H3.1C2.6,8,2.1,7.8,1.8,7.4C1.7,7.3,1.7,7.2,1.7,7c0.1-0.4,0.3-0.8,0.5-1.2c0.1-0.1,0.1-0.3-0.1-0.4 c0,0,0,0,0,0c-0.1-0.1-0.3,0-0.4,0.1C1.4,5.9,1.2,6.4,1,7C0.9,7.4,1,7.9,1.3,8.2c0.3,0.4,0.7,0.6,1.1,0.7c0.3,0,0.5,0,0.8,0 c0.2,0,0.5,0,0.8,0c0.6,0,1.1-0.2,1.5-0.7C5.9,7.7,6,7.1,5.9,6.4c-0.1-0.7-0.1-1.3-0.2-2v0C5.6,3.9,5.6,3.5,5.5,3 c0-0.1,0-0.2,0.1-0.3C5.8,2.5,5.9,2.2,5.9,2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  d: "M13.3,6.1L13.3,6.1c-0.2-0.3-0.6-0.7-0.9-1.1c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7 c0.2,0.3,0.5,0.6,0.7,0.9c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1C13,7,13,7.7,12.7,8.1c-0.5,1-1.5,1.7-2.6,1.7l0,0 c-0.1,0-0.2,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.1l-0.1,0L9,9.7c-0.1,0-0.2,0-0.2,0.1c0,0.1,0,0.1,0.1,0.1c0.2,0.1,0.4,0.1,0.6,0.2 c0.4,0.2,0.9,0.3,1.4,0.3c0,0,0.1,0,0.1,0c1-0.1,1.6-0.7,2.3-1.7c0.3-0.4,0.4-0.8,0.4-1.3C13.8,7,13.6,6.5,13.3,6.1z"
})))));

function SvgRialCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRialCoin);
export default __webpack_public_path__ + "static/media/rial_coin.9882e893.svg";
export { ForwardRef as ReactComponent };